import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue";
import _imports_0 from '@/assets/img/tips/icon_success.svg';
import _imports_1 from '@/assets/img/tips/icon_fail.svg';
var _hoisted_1 = {
  "class": "alert"
};
var _hoisted_2 = {
  "class": "content"
};
var _hoisted_3 = {
  key: 0,
  "class": "alert-status"
};
var _hoisted_4 = {
  key: 0,
  src: _imports_0,
  alt: "",
  srcset: ""
};
var _hoisted_5 = {
  key: 1,
  src: _imports_1,
  alt: "",
  srcset: ""
};
var _hoisted_6 = {
  "class": "text"
};
var _hoisted_7 = {
  "class": "btn-groups"
};
var _hoisted_8 = {
  "class": "confirm"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createBlock(_Transition, {
    name: "fade"
  }, {
    "default": _withCtx(function () {
      return [_ctx.show ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        "class": "mod-mask shadow",
        onClick: _cache[0] || (_cache[0] = function () {
          return _ctx.handlerClick && _ctx.handlerClick.apply(_ctx, arguments);
        }),
        onTouchmove: _cache[1] || (_cache[1] = _withModifiers(function () {}, ["prevent"]))
      }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_ctx.isShowStatus ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_ctx.status ? (_openBlock(), _createElementBlock("img", _hoisted_4)) : (_openBlock(), _createElementBlock("img", _hoisted_5))])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.text), 1)]), _createElementVNode("div", _hoisted_7, [_createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.buttonText), 1)])])], 32)) : _createCommentVNode("", true)];
    }),
    _: 1
  });
}